import PropTypes from 'prop-types';
import React from 'react';
import style from './TableSelect.module.css';

export const TableSelect = ({ value, options, onChange, backgroundColor, color, margin, disabled }) => {
  return (
    <select disabled={disabled} style={{ backgroundColor, color, margin }} value={value} onChange={({ target }) => onChange(target.value)} className={style.select}>
      {options.map(({ label, value }) => (
        <option key={value} value={value}>{label}</option>
      ))}
    </select>
  );
};
TableSelect.defaultProps = {
  disabled: false,
};

TableSelect.propTypes = {
  backgroundColor: PropTypes.any,
  color: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
  margin: PropTypes.string,
  disabled: PropTypes.bool,
};
